export default class QualityOverviewTableDto {
    constructor(obj) {
        this.id = obj[0]
        this.year = obj[1]
        this.status = obj[2]
        this.count = obj[3]
    }
}